import React from 'react'

/**
 * Show which line is which below a chart: a short line in each colour with its name, wrapping
 * onto more rows when there are many
 * @param {Object} props component props
 * @param {Array<{ label: string, colour: string, highlighted: boolean }>} props.items lines in the chart
 * @returns {JSX.Element|null} legend, nothing for a single line
 */
const ChartLegend = ( { items = [] } ) =>
{
  if ( items.length <= 1 ) return null

  return (
    <ul className="chart-legend">
      { items.map( item => (
        <li key={ item.label } className={ item.highlighted ? 'highlighted' : '' }>
          <span className="swatch" style={ { backgroundColor: item.colour } }/>
          { item.label }
        </li>
      ) ) }
    </ul>
  )
}

export default ChartLegend
